import PropTypes from 'prop-types';

export const NewTodoTypes = {
  onNewTodoAdd: PropTypes.func.isRequired,
  onErrorSet: PropTypes.func.isRequired,
};
